import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';

const CanUpgrade: FC = () => {
  const { isLoading, canUpgrade } = useAuthContext();

  return <Middleware isLoading={isLoading}>{canUpgrade ? <Outlet /> : <Navigate to={Routes.DASHBOARD} />}</Middleware>;
};

export default CanUpgrade;
